import React, { Component, Fragment } from 'react'
import {TextInput,
        DateInput
    } from 'react-admin'
import {RichTextInput}from 'ra-input-rich-text';


class Test extends Component {
    constructor(props) {
       // console.log(props)
        super(props);
        this.state = { data: props.data, ftype: props.ftype, render: false };

    }

    componentDidMount() {
        setTimeout(function() { //Start the timer
            this.setState({render: true}) //After 1 second, set render to true
        }.bind(this), 100)

    }

    render () {
        var final = [];
        var queue = [];

       for(var i=1;  i < (eval(`this.state.data.${this.state.ftype}_count`) + 1); i++){

        queue.push(<tr >
                    <td style={{fontWeight:'bold'}}> <TextInput source={`${this.state.ftype}_proced_${i}`}  label='' fullWidth multiline disabled/>
                                                     <TextInput source={`${this.state.ftype}_id_${i}`} style={{ display: 'none', visibility: 'hidden'}} /></td>
                    <td style={{disabled: 'disabled'}}><RichTextInput  source={`${this.state.ftype}_referance_${i}`}  label=""  fullWidth    toolbar={null}  /></td>
                    <td><DateInput source={`${this.state.ftype}_introduced_date_${i}`}    label="" locales="en-us"  locales="en-us"/></td>
                    <td><TextInput source={`${this.state.ftype}_trainer_init_${i}`} label="" /></td>
                    <td><TextInput source={`${this.state.ftype}_trainee_init_${i}`} label="" /></td>
                    <td><DateInput source={`${this.state.ftype}_proficient_date_${i}`}    label="" locales="en-us"  locales="en-us"/></td>
                </tr>)
        }

        if(this.state.render) {
            final = queue;
        }

        return (
            <>{final}</>
        )
    }
}

export default Test